module.exports = __webpack_public_path__ + "img/logo0903_proc.8aaed4cb.jpg";